import { computed, reactive, watch ,onMounted } from 'vue';

export default {
  name: 'tab',
  components: {},
  props: {
    defaultActiveIndex: {
      type: [Number,String],
      default: 0,
    },
    tabText: {
      type: Array,
      default() {
        return [{
          name: 'Tab1',
          val: 'tab1',
          disabled: false,
          alertText: 'N',
        }, {
          name: 'Tab2',
          val: 'tab2',
          disabled: false,
          alertText: '6',
        }, {
          name: 'Disable',
          val: 'disable',
          disabled: true,
          alertText: '3',
        }, {
          name: 'Tab4',
          val: 'tab4',
          disabled: false,
          alertText: '44',
        }]
      },
    },
    theme: {
      type: String,
      default: '1',
    },
    wd: {
      type: String,
      default: 'fixed', // tab wd fixed: 240px, auto: auto 
    }

  },
  setup(props, { emit }) {
    const { defaultActiveIndex, tabText, theme, wd } = props;
    const state = reactive({
      activeIndex: defaultActiveIndex ,
      tabList: tabText,
    })


    onMounted(() => {
      redInit();
    })


    const redInit = ()=>{
      state.tabList.forEach(e => {  
        if(e.val == defaultActiveIndex){ //直接被進入的該tab不會有小紅點
          e.alertText = 0
        }
        if(Math.floor(e.alertText) > 999){   // setting 999+
          e.alertText = '999+'
        }
      });
    }

    const styleClass = computed(() => {
      return [
        `style--theme-${theme}`,
        `wd--${wd}`,
      ]
    })

    watch(
      () => props.tabText,
      (val) => {
        state.tabList = val;
      },
      { deep: true }
    )

    watch(
      () => props.defaultActiveIndex,
      (val) => {
        state.activeIndex = val;
      },
    )

    const onClickTab = (event, index ,item) => {
      event.preventDefault();
      event.stopPropagation();
      if (!state.tabList[index].disabled) {
        state.tabList[index].alertText = '';
        state.activeIndex = index;
        emit('onClick', {index, item});
      }

    }

    return {
      state,
      onClickTab,
      styleClass,
      redInit

    }
  }
}


